import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/endpoints';
import type { SavedQuery, SavedQueryCreate } from '@/features/datasets/types/savedQuery.types';

const key = (datasetId: string) => ['saved-queries', datasetId];

export const useSavedQueries = (datasetId: string) =>
  useQuery({
    queryKey: key(datasetId),
    queryFn: async (): Promise<SavedQuery[]> => (await api.savedQueries.list(datasetId)).data,
    enabled: !!datasetId,
  });

export const useCreateSavedQuery = (datasetId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: SavedQueryCreate): Promise<SavedQuery> =>
      (await api.savedQueries.create(datasetId, data)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: key(datasetId) }),
  });
};

export const useDeleteSavedQuery = (datasetId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      await api.savedQueries.remove(datasetId, id);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: key(datasetId) }),
  });
};
